'use strict';
import React from 'react';
import { DataLoader, SubDataLoader, NewSubDataLoader } from '../../components/Input';
const { getLabel } = OptionUtils;

// 職位
class EDJobPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobs`,
		placeholder: OptionUtils.getLabel('components.EmpUtils', 'posts'),
	};
}

// 保證人
class EDEnsurePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: '/api/ed/options/ensures',
		placeholder: '保證人',
	};
}

// 職等
class EDGradePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/grades`,
		placeholder: '職等',
	};
}

// 職級
class EDLevelPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/levels`,
		placeholder: '職級',
	};
}

// 職等 + 職級
class EDPositionPicker extends SubDataLoader{
	static defaultProps = {
		... SubDataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/positions`,
		placeholder: getLabel('components.EmpUtils', 'gradeGrade'),
		mode: 'all',
	};
}

// 職系
class EDJobSeriesPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobSeries`,
		placeholder: '職系',
	};
}

// 職務類別
class EDJobCatPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobCats`,
		placeholder: '職務類別',
	};
}

// 職種
class EDJobStylePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobStyles`,
		placeholder: '職種',
	};
}

// 職務說明書
class EDJobDescPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobDescs`,
		placeholder: '職務說明書',
	};
}

// 名片職務
class EDJobBizPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/jobBizs`,
		placeholder: '名片職務',
	};
}

// 身分類別
class EDIdentityPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/identities`,
		placeholder: getLabel('components.EmpUtils', 'identityCategory'),
	};
}

// 工作區域
class EDAreaPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/areas`,
		placeholder: '工作區域',
	};
}

// 工作地點
class EDSitePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/sites`,
		placeholder: '工作地點',
		// renderItem: d => <>{d.name} <small className={'msg sm gray'}>代碼: {d.code}</small></>,
	};
}

// 工作區域 + 工作地點
class EDLocationPicker extends NewSubDataLoader{
	static defaultProps = {
		... NewSubDataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/location`,
		placeholder: getLabel('components.EmpUtils', 'workAreaLocation'),
		mode: 'all',
	};
}

// 廠別
class EDFactoryPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/factories`,
		placeholder: '廠別',
	};
}

// 異動原因
class EDVarsCausePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/varsCauses`,
		placeholder: '異動原因',
	};
}

// 獎懲項目
class EDRewardPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/rewards`,
		placeholder: '獎懲項目',
	};
}

// 留停離職原因
class EDQuitCausePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/quitCauses`,
		placeholder: '留停離職原因',
	};
}

// 績效種類
class EDPerfTypePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/perfTypes`,
		placeholder: '績效種類',
	};
}

// 績效評核等級規則
class EDPerfRatingRulePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/perfRatingRules`,
		placeholder: '績效評核等級規則',
	};
}

// 績效評核等級
class EDPerfRatingPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/perfRatings`,
		placeholder: '績效評核等級',
	};
}

// 訓練課程分類
class EDCourseTypePicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/courseTypes`,
		placeholder: '訓練課程分類',
	};
}

// 晉升推薦項目
class EDPromoteItemPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/promoteItems`,
		placeholder: '晉升推薦項目',
	};
}

// 仲介單位
class EDAgentPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/agents`,
		placeholder: '仲介單位',
	};
}

// 就職來源
class EDWorkSrcPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/workSrcs`,
		placeholder: '就職來源',
	};
}

// 簽證類別
class EDVisaTypePicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/visaTypes`,
		placeholder: '簽證類別',
	};
}

// 員工契約種類
class EDDealPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/deals`,
		placeholder: '員工契約種類',
	};
}

// 健康狀況異常項目
class EDHealthPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/healths`,
		placeholder: '健康狀況異常項目',
	};
}

// 領取物品
class EDReceiveItemPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/receiveItems`,
		placeholder: '領取物品',
	};
}

// 派遣公司
class EDAccreditPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/accredits`,
		placeholder: '派遣公司',
	};
}

// 建教類別
class EDCoopTypePicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/coopTypes`,
		placeholder: '建教類別',
	};
}

// 建教班別
class EDCoopClassPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/coopClasses`,
		placeholder: '建教班別',
	};
}

// 交通車班別
class EDCoopCarPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/coopCars`,
		placeholder: '交通車班別',
	};
}

// 住宿類別
class EDCoopStayPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/coopStays`,
		placeholder: '住宿類別',
	};
}

// 應繳交資料
class EDDeliverItemPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/deliverItems`,
		placeholder: '應繳交資料',
	};
}

// 學校代碼
class EDSchoolPicker extends DataLoader {
	static defaultProps = {
		...DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/schools`,
		placeholder: '學校代碼',
	};
}

// 出差性質
class EDBizPropertyPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/bizProperty`,
		placeholder: '出差性質',
	}
}

// 出差地點
class EDBizAreaPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/bizArea`,
		placeholder: '出差地點',
	}
}

// 交通工具
class EDBizTransPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/bizTrans`,
		placeholder: '交通工具',
	}
}

// 委辦事項
class EDBizTodoPicker extends DataLoader {
	static defaultProps = {
		... DataLoader.defaultProps,
		api: bid => `/api/ed/options/${bid}/bizTodo`,
		placeholder: '委辦事項',
	}
}

export {
	EDJobPicker, EDEnsurePicker, EDGradePicker, EDLevelPicker, EDPositionPicker,
	EDJobSeriesPicker, EDJobCatPicker, EDJobStylePicker, EDJobDescPicker, EDJobBizPicker,
	EDIdentityPicker, EDAreaPicker, EDSitePicker, EDLocationPicker, EDFactoryPicker,
	EDVarsCausePicker,
	EDPerfTypePicker,
	EDPerfRatingRulePicker, EDPerfRatingPicker, EDRewardPicker, EDQuitCausePicker,
	EDCourseTypePicker, EDPromoteItemPicker,
	EDAgentPicker, EDWorkSrcPicker, EDVisaTypePicker, EDDealPicker, EDHealthPicker, EDReceiveItemPicker, EDAccreditPicker,
	EDCoopTypePicker, EDCoopClassPicker, EDCoopCarPicker, EDCoopStayPicker,
	EDDeliverItemPicker, EDSchoolPicker,
	EDBizPropertyPicker, EDBizAreaPicker, EDBizTransPicker, EDBizTodoPicker,
};
